(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/date-for-limit-update.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/date-for-limit-update.js');
'use strict';

const _svs$accountservicesR = svs.accountservicesReact.gameLimitDepositsForm,
  AmountWithCurrency = _svs$accountservicesR.AmountWithCurrency,
  DateTimeText = _svs$accountservicesR.DateTimeText;
const DateForLimitUpdate = _ref => {
  let allLimits = _ref.allLimits,
    hasMarginBottom = _ref.hasMarginBottom,
    hasMarginTop = _ref.hasMarginTop,
    isNewlyUpdatedLimits = _ref.isNewlyUpdatedLimits;
  const limits = allLimits.filter(limit => limit.nextTimeShift !== null && limit.currentDepositBudget !== limit.futureDepositBudget).reverse();
  const LIMIT_NAMES = {
    DAY: 'dagsgräns',
    WEEK: 'veckogräns',
    MONTH: 'månadsgräns'
  };
  const baseClass = limits.length > 0 ? 'bg-tur-100 u-border-radius-4 align-center padding-1' : '';
  const topMarginClass = hasMarginTop ? 'margin-top-2' : '';
  const bottomMarginClass = hasMarginBottom ? 'margin-bottom-1' : '';
  if (limits.length === 0) {
    return null;
  }
  return React.createElement("div", {
    className: "".concat(baseClass, " ").concat(topMarginClass, " ").concat(bottomMarginClass)
  }, isNewlyUpdatedLimits && React.createElement("p", {
    className: "f-bold"
  }, "Dina \xE4ndringar \xE4r sparade"), React.createElement("ul", {
    className: "padding-0",
    role: "list"
  }, limits.map(limit => React.createElement("li", {
    key: limit.limitType
  }, "Din nya", ' ', LIMIT_NAMES[limit.limitType], ' - ', React.createElement(AmountWithCurrency, {
    amount: parseInt(limit.futureDepositBudget, 10)
  }), ' - ', "g\xE4ller fr\xE5n", ' ', React.createElement(DateTimeText, {
    datetime: limit.nextTimeShift
  })))));
};
svs.accountservicesReact.gameLimitDepositsForm.DateForLimitUpdate = DateForLimitUpdate;

 })(window);